import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { filter, switchMap } from 'rxjs';
import { AppState, AppStateService } from '../../utils/app-state.service';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './navigation/navigation.component';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrl: './full-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, MatButtonModule, MatIconModule, HeaderComponent, NavigationComponent]
})
export class FullLayoutComponent {
  private readonly cookieService = inject(CookieService);
  private readonly apiService = inject(AppStateService);
  private readonly router = inject(Router);

  private readonly cookieName = 'cookieBanner';
  protected readonly cookieBannerClosed = signal(false);
  protected readonly appState = signal<AppState>(null);

  constructor() {
    this.cookieBannerClosed.set(this.cookieService.check(this.cookieName));

    this.router.events.pipe(
      takeUntilDestroyed(),
      filter(event => event instanceof NavigationEnd),
      switchMap(_ => this.apiService.getState())
    ).subscribe(state => this.appState.set(state));
  }

  protected closeCookieBanner(): void {
    this.cookieService.set(this.cookieName, 'closed', 10000);
    this.cookieBannerClosed.set(true);
  }
}
